import { Pipe, PipeTransform } from '@angular/core';
import { MainPricePipe } from './main-price.pipe';
import { Offer } from '../../core/models/offer/offer.model';

@Pipe({
  name: 'offerMainPrice'
})
export class OfferMainPricePipe extends MainPricePipe implements PipeTransform {

  transform(value: any | Offer, selectedPremium?: string): any {
    return value.hasOwnProperty('premiums') ? super.transform(Offer.getOfferPrice(value, selectedPremium)) : super.transform(value);
  }
}
